const availableLocales = ['pt-BR', 'en', 'es']
const defaultLocale = 'pt-BR'

const getFallbackLocale = (locale = null) => {
  if (/pt-/.test(locale)) return 'pt-BR'
  if (/en-/.test(locale)) return 'en'
  if (/en/.test(locale)) return 'en'
  if (/es-/.test(locale)) return 'es'
  if (/es/.test(locale)) return 'es'

  return defaultLocale
}

const getLocale = async locale => (await import(`@/locales/${getFallbackLocale(locale)}.json`)).default

export default {
  availableLocales,
  defaultLocale,
  getFallbackLocale,
  getLocale,
}
